import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity Club
 */
@Entity()
export class Club extends Partner {
  static override _class = 'Club';

  override get type() {
    return KooperationsPartner.CLUB;
  }
}
